<template>
    
<div>

  <div class="card border-left-primary shadow h-100  p-2">
        <h4 class="text-primary font-weight-bolder">Тағирдиҳии китоб</h4>
        <hr />

     
            <div class="container-fluid">

 
                <div class="row">

                    <div class="col-3  " style="max-width:300px" id="hhpart">



                        <div class="card card-header shadow">

                            <label for="f1" class="form-label">Рақами китоб</label>
                            <div class="input-group mb-3">

                     
                                <input type="text" ref="number"  class="form-control" :value="this.$store.state.book.Number">

                            </div>

                            <label for="f1" class="form-label">Суроға</label>
                            <div class="input-group mb-3">


                               <select class="form-control" ref="idter" :value="this.$store.state.book.Idter">
                                    <option v-for="t in this.$store.state.ter" :key="t"  :value="t.Terid">{{t.NameTJ}}</option>
                                </select>
                            </div>

                            <label for="f1" class="form-label">Эзоҳ </label>
                            <div class="input-group mb-3">

                                <input type="text" class="form-control" ref="comment" :value="this.$store.state.book.Comment" >
                            </div>

            

        

                            <div class="form-group text-center mt-5">
                                <button  class="btn btn-primary" @click="update" >Сабткунӣ</button>

                                <button   @click="cancel" class="btn btn-danger ms-2" >Отмена</button>
                            </div>
                        </div>
                    </div>

                   
                </div>
            </div>

  

    </div>

</div>

   



</template>

<script>


export default {
    data() {
        return {}
    },
    methods:{

update(){


this.$store.state.book.Number=this.$refs.number.value;
this.$store.state.book.Idter=this.$refs.idter.value;
this.$store.state.book.Comment=this.$refs.comment.value;


this.$api("/api/data/", {
  method: "post",
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },

  body: JSON.stringify(this.$store.state.book)
})
//.then(response =>  response.json())
.then(data => console.log('data',data));

console.log(this.$router.options.history.state.back);
this.$router.go(-1);
},


cancel(){
this.$router.go(-1);

}

    },

    mounted(){

        console.log('book', this.$store.state.book)
        console.log('ter', this.$store.state.ter)

    }
}
</script>
